<template>
  <Form class="md:w-1/3 flex flex-col gap-3" @submit="(values) => onSubmit(values)">
    <Field
      :rules="requiredRule"
      validate-on-input
      validate-on-change
      validate-on-blur
      name="password"
      v-slot="{ field, errors: errs }"
    >
      <TextInput
        :field="field"
        :errors="errs"
        :label="$t('pleaseEnterPassword')"
        input-type="password"
        label-class="w-full"
        class="w-full"
        direction="flex-col"
      />
    </Field>
    <button
      class="text-center rounded-md bg-primary/80 hover:bg-primary flex items-center gap-x-2 hover:scale-[1.02] active:scale-100 disabled:bg-gray-300 disabled:hover:scale-95 disabled:cursor-not-allowed text-white"
    >
      <span class="w-full text-center py-1.5">
        {{ $t('Verify') }}
      </span>
    </button>
  </Form>
</template>

<script setup>
import TextInput from '@/components/SimpleForm/TextInput.vue'
import axiosInstance from '@/services'
import { Field, Form } from 'vee-validate'
import { useI18n } from 'vue-i18n'

const emit = defineEmits(['onSuccess'])
const i18n = useI18n()

function requiredRule(value) {
  if (!value || !`${value}`.trim()) {
    return i18n.t('INVALID_REQUIRED')
  }

  return true
}

const onSubmit = async (form) => {
  const path = `/api/user/verifyPasswordForTwoStepAuthentication/${form.password}`
  const response = await axiosInstance.get(path)

  if (response) {
    emit('onSuccess')
  }
}
</script>

<style lang="scss" scoped></style>
